import ZoomContainer from './ZoomContainer';
import app from '../../public-api';
import { makeOverlayExtension } from '../viewport-overlay';

const zoomContainerLoader = {
  name: 'us:zoom-control-container',

  extends: 'viewport',

  dependencies: ['us:user-config'],

  constructor: makeOverlayExtension({
    components: { ZoomContainer },
    layoutOptions: { divClass: 'zoom-container', precinct: 'BL', order: 1 }
  })
};

app.plugins.register(zoomContainerLoader);



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/zoom/zoom-loader.js